module.exports = __webpack_public_path__ + "static/media/6.f03d76a8.png";